import { BaseItem, TableProps } from '@lib/components/Table/types';

export const checkHasSelectColumn = <T extends BaseItem>({
  actionsForSelected,
  hasSelectColumn,
  useBulkSelectResult,
}: TableProps<T>): boolean =>
  !!useBulkSelectResult && (!!actionsForSelected?.length || !!hasSelectColumn);
